import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as classifiedActions from 'reduxBits/classified/actions'
import * as searchParamsActions from 'reduxBits/searchParams/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      event: 'event',
      eventType: 'Engagement',
      objectType: 'UIElement',
      objectFilterSearchNumResults: _.get(
        state,
        'classified.searchResults.searchTotal',
        '',
      ).toString(),
    },
    ...localData,
  })

export const clickedShowFilter = {
  validators: [validators.redux(classifiedActions.SHOW_FILTER)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'show_filter_button',
        objectName: 'Show filter options',
        intent: 'Show',
      }),
    ),
  ],
}

export const clickedCancelFilter = {
  validators: [validators.redux(classifiedActions.CANCEL_FILTER)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'cancel_filter_button',
        objectName: 'Cancel filter options',
        intent: 'Dismiss',
      }),
    ),
  ],
}

export const clickedClearFilter = {
  validators: [validators.redux(searchParamsActions.CLEAR_FILTER)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'clear_filter_button',
        objectName: 'Clear filter options',
        intent: 'Delete',
      }),
    ),
  ],
}

export const clickedShowAds = {
  validators: [validators.redux(searchParamsActions.SHOW_ADS)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'show_ads_button',
        objectName: 'Show ads button',
        intent: 'Show',
      }),
    ),
  ],
}
